import { useState } from 'react';
import { Siren, ChevronDown, ChevronUp, Crosshair, Navigation } from 'lucide-react';
import { MAINT, objPos } from '../lib/maint';
import { routeLink } from '../lib/route';

// leaks + all red / yellow parts of the network
export const alarmObjects = (project) => [
  ...project.fittings.map((o) => [o, 'fitting']), ...(project.pipes || []).map((o) => [o, 'pipe']), ...(project.pits || []).map((o) => [o, 'pit'])]
  .filter(([o]) => o.type === 'leak' || ['warn', 'defect'].includes(o.maint?.status))
  .map(([o, kind]) => ({ o, kind, pt: objPos(o, kind, project.fittings), level: o.type === 'leak' || o.maint?.status === 'defect' ? 'defect' : 'warn' }))
  .filter((x) => x.pt)
  .sort((a, b) => (b.level === 'defect') - (a.level === 'defect'));

export default function AlarmCard({ t, project, onLocate }) {
  const [open, setOpen] = useState(false);
  const list = alarmObjects(project);
  if (!list.length) return null;
  const red = list.filter((x) => x.level === 'defect').length;
  return (
    <section className="panel alarm-card" data-testid="alarm-card">
      <button className="overdue-head" data-testid="alarm-toggle-btn" onClick={() => setOpen(!open)}>
        <Siren size={20} />
        <span><b>{t.alTitle}</b><small>{red} {t.alRed} · {list.length - red} {t.alYellow}</small></span>
        <em className="count" data-testid="alarm-count">{list.length}</em>
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
      {open && (
        <ul className="alarm-list" data-testid="alarm-list">
          {list.map(({ o, kind, pt, level }, i) => (
            <li key={o.id} data-testid={`alarm-item-${i}`}>
              {o.media?.find((m) => m.kind === 'photo') ? <img className="alarm-thumb" data-testid={`alarm-thumb-${i}`} src={(o.media.find((m) => m.kind === 'photo')).data} alt="" /> : <i style={{ background: MAINT[level] }} />}
              <span><b>{o.name || t['fit_' + o.type]}</b><small>{o.type === 'leak' ? `${t.fit_leak} · ${t['sev_' + (o.severity || 'medium')]}` : t['mt_' + o.maint.status]}{o.maint?.tags?.length ? ` – ${o.maint.tags.join(', ')}` : ''} · {t['objKind_' + kind]}</small></span>
              <button className="btn btn-outline btn-sm" data-testid={`alarm-locate-btn-${i}`} onClick={() => onLocate(pt)}><Crosshair size={14} /> {t.alShow}</button>
              <a className="btn btn-green btn-sm" data-testid={`alarm-nav-btn-${i}`} href={routeLink({ lat: pt[0], lon: pt[1] })} target="_blank" rel="noreferrer"><Navigation size={14} /> {t.alNav}</a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
